export const ZENDESK_CHAT_PARTNER = 'zendeskChatPartner';
export const allowedPartner = {
  revolut: 'revolut',
  amazonGroup: 'amazon',
};

export type Position = 'tab';

/**
 * key: partner slug
 */
export const ZENDESK_CHAT_APP_ID: Partial<Record<string, string>> = {
  [allowedPartner.revolut]: '517074fc-dd89-474e-9f5f-adf6b35d570c',
  [allowedPartner.amazonGroup]: 'c77739ee-fa75-4122-b54f-ba77fbc7f282',
};

export const isAmazonGroup = (partnerSlug: string) => partnerSlug.toLowerCase().includes(allowedPartner.amazonGroup);
